import CornerSupport from "./CornerSupport";

export default CornerSupport;
